<template>
    <div class="e-square-items">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: `e-square-items`,
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.e-square-items {
    display: block;
}
</style>
